import React from "react";
import TrsNavBar from "components/Trs/TrsNavBar";
import TrsHeader from "components/Trs/TrsHeader";
import HeaderImage from "../../images/stdcareheader.png"
import Content from "./Content";
import TrsFooter from "components/Trs/TrsFooter";
import TrsCookies from "components/Trs/TrsCookies";
import PromoBanner from "../../components/common/PromoBanner";
import "../../css/trsactivecare.scss";

export default function TrsCareStandard() {
  document.title = "RediMD - TRS Care Standard"
  return (
    <>
      {/* Navigation */}
      <TrsNavBar />
      
      {/* Promo Banner */}
      <PromoBanner backgroundColor="#24628F" />

      {/* Header - set the background image for the header in the line below */}
      <TrsHeader bgImage={HeaderImage} />

      {/* Content section */}
      <Content />

      {/* Footer */}
      <TrsFooter />

      {/* GDPR cookie message Start */}
      <TrsCookies />
    </>
  );
}
